export default __webpack_public_path__ + "KaTeX_Math-Italic.ffda88030bb30ae4a0f437dd9f86add2.woff2";